var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaperclip = function SvgPaperclip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343754",
    fillRule: "nonzero",
    d: "M18.526 2.493C19.509 3.463 20 4.642 20 6.031c0 1.388-.491 2.58-1.474 3.576l-7.211 7.114c-.213.183-.412.183-.598 0-.186-.184-.186-.38 0-.59l7.211-7.114c.85-.812 1.275-1.794 1.275-2.947s-.425-2.149-1.275-2.987c-.823-.812-1.82-1.218-2.988-1.218-1.195 0-2.204.406-3.028 1.218L1.713 13.144a2.82 2.82 0 0 0-.876 2.083c0 .812.292 1.507.876 2.083a2.898 2.898 0 0 0 2.112.865c.823 0 1.527-.289 2.111-.865l9.761-9.668c.24-.236.359-.537.359-.904 0-.34-.12-.629-.359-.865a1.163 1.163 0 0 0-.896-.393c-.359 0-.658.131-.897.393l-7.25 7.114c-.187.21-.386.21-.598 0-.213-.21-.213-.406 0-.59l7.21-7.152c.4-.393.904-.59 1.515-.59.61 0 1.115.197 1.514.59.398.445.597.943.597 1.493 0 .603-.199 1.1-.597 1.493L6.534 17.9c-.797.733-1.7 1.1-2.71 1.1-1.009 0-1.912-.367-2.708-1.1C.372 17.14 0 16.242 0 15.207c0-1.035.372-1.919 1.116-2.652L11.315 2.493C12.324 1.498 13.533 1 14.94 1c1.381 0 2.577.498 3.586 1.493z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperclip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paperclip.c10d80f1.svg";
export { ForwardRef as ReactComponent };